export const MAX_RETRIES = 5;